<div class="flex flex-col gap-3">
    <div class="flex flex-col gap-2 shadow bg-slate-100 rounded-md text-md">
        <magic-card-face-text 
            [magicCard]="magicCard!" 
            [magicCardFace]="frontFace!" 
            [isBackface]="false" 
            [isTranslation]="isTranslation"></magic-card-face-text>
    </div>
    
    @if (backFaces) {
        @for (face of backFaces ; track face.name) {
            <div class="flex flex-col gap-2 shadow bg-slate-100 rounded-md text-md">
                <magic-card-face-text 
                    [magicCard]="magicCard!" 
                    [magicCardFace]="face!" 
                    [isBackface]="true" 
                    [isTranslation]="isTranslation"></magic-card-face-text>
            </div>
        }
    }
</div>
